import { Box, Container, Grid, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import React from 'react'
import { Navigate } from 'react-router-dom'
import StageVolkswagen from '../../components/brands/vw/StageVolkswagen'
import WarrantyRegistrationForm from '../../components/forms/WarrantyRegistrationForm'
import { brandImages, getBrandsDict } from '../../constants/brands'
import { useAuth } from '../../hooks/context/UserAuthContext'

const Root = styled(Box)(`

  overflow-x: hidden;
  background: #000;
  background: linear-gradient(180deg,#000 0,#2e2e2e 300px,#000 1000px);
`)

const WarrantyRegistrationVW = () => {
  const { user } = useAuth()
  const brandsDict = getBrandsDict('vw')
  if (user) {
    switch (user.dealershipBrand) {
      case 'vw':
        break
      default:
        return <Navigate to='/register-warranty' replace />
    }
  }
  return (
    <Root
      minHeight={{ xs: 'calc(100vh - 64px)', sm: 'calc(100vh - 72px)' }}
      maxWidth={{ xs: '100vw', sm: 'calc(100vw - 18px)' }}
    >
      <StageVolkswagen />
      <Box width='100%' sx={{ background: '#fff' }}>
        <Container maxWidth='md' sx={{ py: 2 }}>
          <Box mb={2}>
            <Typography variant='h5'>Participating Brands:</Typography>
            <Grid container justifyContent='center' textAlign='center'>
              {Object.keys(brandsDict).map((brand) => (
                <Grid item key={brand} mt={2} xs={12} sm={6} md={4}>
                  <Box
                    mx='auto'
                    component='img'
                    src={`/images/logos/transparent/${brandImages[brand] || brand}.png`}
                    alt={brandsDict[brand]?.fullName ?? brand}
                    style={{ maxHeight: 55, maxWidth: 320 }}
                  />
                </Grid>
              ))}
            </Grid>
          </Box>
          <Box mb={2}>
            <Typography variant='h5'>Warranty Registration</Typography>
          </Box>
          <WarrantyRegistrationForm dealershipBrand='vw' />
        </Container>
      </Box>
    </Root>
  )
}

export default WarrantyRegistrationVW
